export default (x: number | string, decimal?: number) => {
    let num = x;
    if (decimal) {
        num = (+num).toFixed(decimal);
    }
    const numParts = num.toString().split('.');
    numParts[0] = numParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return numParts.join('.');
};
